import { create } from 'apisauce'

import store from '../store'
import handleNetworkError from '../actions/network'
import { refreshUserToken } from '../actions/user'
import { getAPIEndpoint } from '../utils/apiConstants'
import { logout } from '../actions/application'


const baseURL = `${getAPIEndpoint()}/system`
const newApiSystem = create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const checkForToken = () => `bearer ${store.getState().user && store.getState().user.access_token}`
// const checkForToken = () => 'bearer faketoken'

newApiSystem.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: { ...config.headers,
        Authorization: checkForToken(),
        // FIX: for GET requests
        // more in: https://github.com/infinitered/apisauce/issues/120
        'Content-Type': 'application/json',
      },
    }
    return newConfig
  },
  (error) =>
    // Do something with request error
    // console.log('request interceptor error')
    Promise.reject(error)
  ,
)

newApiSystem.axiosInstance.interceptors.response.use(
  response => (
    response
  ), error => {
    if (error.response) {
      const statusCode = error.response.status
      if (statusCode === 401) {
        store.dispatch(logout())
      } else if (statusCode === 403) {
        store.dispatch(refreshUserToken())
      }
      store.dispatch(handleNetworkError(error.response.status, error.response.data))
    }
    return Promise.reject(error)
  })

export default newApiSystem
